import { LocationType } from '../../imup/types'

export const BEAM_BUNDLE_NAME_BY_LOCATION: LocationType[] = [LocationType.SCREEN_PORCH, LocationType.SUNROOM]
